import { BALLOON, FINANCE, LEASE } from '@makemydeal/dr-platform-types';
import type { OfferType } from '@makemydeal/dr-platform-types';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

import * as offerReduxSelectors from './offerRedux';

export const PRIOR_BALANCE_SUPPORTED_OFFER_TYPES: OfferType[] = [FINANCE, LEASE, BALLOON];

export const isPriorBalanceSupportedForOfferType = (offerType: OfferType): boolean =>
    PRIOR_BALANCE_SUPPORTED_OFFER_TYPES.includes(offerType);

export const isPriorBalanceApplicable = (state: StateTree): boolean =>
    featureToggleSelectors.isPriorBalanceEnabled(state) &&
    isPriorBalanceSupportedForOfferType(offerReduxSelectors.getCurrentOfferType(state));

export const getPriorBalanceAmountForPrint = (state: StateTree, offerType: OfferType): number | undefined => {
    if (!featureToggleSelectors.isPriorBalanceEnabled(state) || !isPriorBalanceSupportedForOfferType(offerType)) {
        return undefined;
    }

    return offerReduxSelectors.getPriorLeaseBalance(state).amount;
};
